<ion-card *ngFor="let ad of ads" class="content-width" button style="max-height: 100px;" (click)="openUrl(ad)">
    <ion-row>
        <ion-col size="8">
            <ion-card-header>
                <ion-card-subtitle>{{ ad.subtitle }}</ion-card-subtitle>
                <ion-card-title>{{ ad.title }}</ion-card-title>
            </ion-card-header>
        </ion-col>
        <ion-col size="4">
            <div style="line-height: 100px; vertical-align: middle;">
                <ion-img style="height: 65px;" [src]="ad.imageUrl"></ion-img>
            </div>
        </ion-col>
    </ion-row>
</ion-card>